// Library methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

// MUI Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Skeleton from "@mui/material/Skeleton";
import { HomeIcon } from "../../../assets/icons";

// Utils
import { getTruncatedText } from "../../../utils/textHelper";

const Breadcrumb = ({ isLoading, patientId, patientName, pageName }) => {
  const { t } = useTranslation();

  const formattedPatientName = useMemo(
    () => getTruncatedText(patientName),
    [patientName]
  );

  return (
    <Box display="flex" alignItems="center" mt={4} mb={1}>
      <Link
        color="inherit"
        component={RouterLink}
        to="/patients"
        state={{ user: patientId, fromReport: true }}
        sx={{ display: "flex", alignItems: "center", mt: "8px", mr: "8px" }}
      >
        <HomeIcon />
      </Link>
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          color="inherit"
          component={RouterLink}
          className="capitalize"
          to="/patients"
          state={{ user: patientId, fromReport: true }}
          sx={{ display: "flex" }}
        >
          {t("patients_title")}
          {isLoading ? (
            <Skeleton sx={{ width: 50, ml: 1 }} />
          ) : (
            ` (${formattedPatientName})`
          )}
        </Link>
        <Typography color="text.primary" className="capitalize">
          {pageName ?? t("word_report")}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
